import axios, { AxiosResponse } from 'axios';

export interface IKoducastnika {
    kodyucastnika: [
        {
            kod: string;
            nazev: string;
        }
    ];
}

/* Vrátí seznam kódů účastníka */
export const ueKoducastnika = () => {
    return axios({
        method: 'GET',
        url: '/UE/koducastnika'
    }).then((resp: AxiosResponse<IKoducastnika>) => resp.data);
};
